const ColorSF2 = {
  white: '#FFFFFF',
  black: '#000000',
  transparentBlack: '#00000029',
  paleBlue: '#CCD9E7',
  deepBlack: '#1F1F1F',
  mediumGray: '#ACACAC',
  darkGray: '#2F3243',
  navyBlue: '#014386',
  alertRed: '#E24242',
  red: '#C3291C',
  offWhite: '#F2F5F9',
  twilightBlue: '#40518B',
  skyBlue: '#A3BBD4',
  skyBlue80: 'rgba(163, 187, 212, 0.8)',
  brightBlue: '#006FFB',
  lightBlue: '#AFC2D6',
  charcoalGray: '#666666',
  lightGray: '#EBEBEB',
  green: '#97C15C',
  mintGreen: '#51BD65',
  transparentShadow: '#00000030',
  ceruleanBlue: '#4994ec',
  steelGray: '#6E6E6E',
  whisperGray: '#F5F5F5',
  softPink: '#FFAAAA',
  darkGrayTransparent: '#201F2CCC',
  silverGray: '#D3D3D3',
  lighterGray: '#e9e9e9',
};

export default ColorSF2;
